import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  doneLoadingContainer: modalHeight => ({
    height: modalHeight,
    marginHorizontal: 16,
    flex: 1,
    justifyContent: 'space-between',
  }),
  tickAndMessageContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  doneLoadingMainTitle: theme => ({
    fontSize: 24,
    lineHeight: 32,
    color: theme.colors.textColor,
    marginTop: 34,
    fontWeight: 'bold',
  }),
  doneLoadingSubTitle: theme => ({
    fontSize: 16.8,
    lineHeight: 20,
    color: theme.colors.textColor,
    marginTop: 22,
    fontWeight: '300',
    textAlign: 'center',
  }),
  doneLoadingReturnButton: {
    width: '100%',
  },
  doneLoadingReturnButtonText: {
    fontSize: 16,
  },
  secondButtonStyle: {
    marginTop: 17.1,
  },
  icon: {
    height: 125,
    width: 125,
    marginTop: -16,
  },
});
